const camelToHuman = (str) => {
  return str
    .replace(/[a-z][A-Z]/g, (c) => `${c[0]} ${c[1]}`)
    .replace(/^\w/, (c) => c.toUpperCase());
};

export { camelToHuman };
